import { Stack } from 'braid-design-system';

import SkeletonLine from 'src/components/SkeletonLine/SkeletonLine';

import { CareerFeedAIAssistantContainer } from './CareerFeedAIAssistantContainer';
import { CareerFeedAIAssistantContent } from './CareerFeedAIAssistantContent/CareerFeedAIAssistantContent';
import { useRefreshRecsWhenRefined } from './CareerFeedAIAssistantContent/ConversationFinished';
import { CareerFeedMobileWebFeatureFlagContainer } from './CareerFeedMobileWebFeatureFlagContainer';
import { useCareerFeedAIAssistant } from './hooks/useCareerFeedAIAssistant';
import { useRecommendationForCareerFeedAiAssistant } from './hooks/useRecommendationForCareerFeedAiAssistant';

const RECOMMENDED_JOBS_SPACE = 'small';

/** *
 * This component is responsible for displaying the AI Assistant for the Career Feed.
 * This is still in in discovery phase and the implementation of this component might change drastically.
 * The reason why this is in the code base is so that people can start playing around with it
 * and get feedback on the implementation.
 */
export const CareerFeedAIAssistant = () => {
  const {
    error: isRecommendationError,
    loading: isRecommendationLoading,
    isRefreshLoading,
    jobIds,
  } = useRecommendationForCareerFeedAiAssistant();

  const { persistedCandidateChatContext, progress } =
    useCareerFeedAIAssistant();

  const jobsCount = jobIds.length;
  const isLoadingState =
    (isRecommendationLoading && !isRefreshLoading) ||
    (progress === 'initial' && isRefreshLoading);

  useRefreshRecsWhenRefined();

  if (isRecommendationError) {
    return null;
  }

  if (!persistedCandidateChatContext && !isLoadingState && jobsCount === 0) {
    return null;
  }

  return (
    <CareerFeedMobileWebFeatureFlagContainer
      mobileView={<CareerFeedAIAssistantContent />}
      tabletAndAboveView={
        <Stack space={RECOMMENDED_JOBS_SPACE}>
          <CareerFeedAIAssistantContainer showHeading={!isLoadingState}>
            {isLoadingState ? (
              <Stack space="medium">
                <SkeletonLine type="text" width={200} size="small" />
                <SkeletonLine type="text" width={260} size="xsmall" />
              </Stack>
            ) : (
              <CareerFeedAIAssistantContent />
            )}
          </CareerFeedAIAssistantContainer>
        </Stack>
      }
    />
  );
};
